import React, { useState, useEffect, useContext, useActionState } from "react";
import "../../styles/global.css";
import {
  Paper,
  Toolbar,
  InputAdornment,
  TableBody,
  TableRow,
  TableCell,
  Select,
  Chip,
  Grid,
  MenuItem,
  Typography,
  TextField,
} from "@material-ui/core";
import Controls from "../../components/controls/Controls";
import Axios from "axios";
import useTable from "../../components/useTable";
import { BatteryUnknownOutlined, Check, Height, HeightOutlined, Search, Style } from "@material-ui/icons";
import DetailProduct from "./detail";
import WarningIcon from "@material-ui/icons/Warning";
import ProductCompletion from "../management/completion";
// import ProductDeletion from "../management/deletion";
import { baseUrl } from "../../config/const";
// import ArchiveProduct from "../management/archiveProduct";
import { AuthContext } from "../../AppContext";
import Checkbox from "@material-ui/core/Checkbox";
import { Autocomplete } from "@material-ui/lab";

export default function IncompleteProducts() {
  const { state, dispatch } = useContext(AuthContext);
  const headCells = [
    { id: "select", label: "", disableSorting : true },
    { id: "sku", label: "SKU" },
    { id: "pname", label: "Product Name", disableSorting: true },
    { id: "brand", label: "Brand" },
    { id: "koleksi", label: "Koleksi", disableSorting: true },
    { id: "type", label: "Tipe Produk", disableSorting: true },
    { id: "usage", label: "Peruntukkan Produk", disableSorting: true },
    { id: "gender", label: "Gender", disableSorting: true },
    { id: "age_group", label: "Age Group", disableSorting: true },
    { id: "harga", label: "Harga"},
    { id: "stok", label: "Stok"},
    { id: "tglms", label: "Date Registered"},
    
  ];
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  // supaya bisa text filtering
  const filteredRecords = filterFn.fn(state.incompleteProductList);
  // helper untuk SKUs' filtered
  const [searchText, setSearchText] = useState("");
  const isFiltering = searchText.trim() !== "";
  const filteredSKUs = isFiltering ? filteredRecords.map(r => r.sku) : [];
  const [selectedSKU, setSelectedSKU] = useState([]);

  const allFilteredSelected = isFiltering && filteredSKUs.length > 0 && filteredSKUs.every(sku => selectedSKU.includes(sku));

  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
    location: "",
  });
  // const [openPopup, setOpenPopup] = useState(false);
  const [confirmPopup, setConfirmPopup] = useState({
    isOpen: false,
    title: "",
    subtitle: "",
  });

  const [openBulkPopup, setOpenBulkPopup] = useState(false);



  //helper checkbox
  const handleCheckboxSKU = (sku) => {
    setSelectedSKU((prev) => {
      if(prev.includes(sku)){
        return prev.filter((s) => s !== sku)
      }else {
        return [...prev, sku]
      }
    })
  }

  /**
   * return results of useForm helper method
   * @param records are the data from db
   * @param headCells header of the table
   * @param filterFn filtering function that carries the records
   */
  const { TblHead, TblContainer, TblPagination, recordsAfterPagingAndSorting } =
    useTable(filteredRecords, headCells, {
      fn: items => items
    });

  /**
   * @returns records of all products
   */
  const getIncompleteProducts = async () => {
    await Axios.get(`${baseUrl}/getIncompleteProducts`)
      .then((response) => {
        dispatch({
          type: "UPDATE_LIST",
          payload: {
            incompleteProductList: response.data.records,
          },
        });
      })
      .catch((err) => {
        setNotify({
          message: "error",
          isOpen: true,
          type: "error",
        });
      });
  };


  /**
   *
   * @param {*} e indicates the search event
   */
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchText(value);
    // let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (value === "") {
          return items;
        } else {
          return items.filter((x) => x.sku.includes(value));
        }
      },
    });
  };
  useEffect(() => {
    getIncompleteProducts();
  }, []);

  function BulkEditProducts({skus, setSelectedSKU, refreshList,closeModal}){
    const [form,setForm] = useState({
      brand: null,
      gender: null,
      agegroup: null,
      type: null,
      usage: null,     // array
      koleksi: null,      
    })

    const [productProps, setProductProps] = useState({
      brands: [],
      genders: [],
      agegroups: [],
      types: [],
      usages: [],
      koleksis: []
    });    

    const getProductProperties = async () => {
      try {
        const res = await Axios.get(`${baseUrl}/getProductProperties`);
          setProductProps(res.data);
      } catch (err) {
        console.log(err);
        setNotify({
          message: "Error get product properties",
          isOpen: true,
          type: "error"
        });
      }
    };
const [saving, setSaving] = useState(false);

const submitBulkUpdate = async () => {
    if (
    !form.brand &&
    !form.gender &&
    !form.agegroup &&
    !form.type &&
    !form.usage &&
    !form.koleksi
  ) {
    alert("Tidak ada field yang diisi. Tidak ada yang diupdate.");
    return;
  }
  try {
    setSaving(true);
    await Axios.post(`${baseUrl}/bulkUpdateProducts`, {
      skus,
      ...form
    });

    setNotify({
      isOpen: true,
      message: `Berhasil update ${skus.length} produk`,
      type: "success"
    });

    await refreshList();

    setSelectedSKU([]);
    closeModal();


    // Optional:
    // refresh list
    // close modal
    // clear selectedSKU
  } catch (err) {
    console.error(err);
    setNotify({
      isOpen: true,
      message: "Gagal bulk update produk",
      type: "error"
    });
  }
  finally{
    setSaving(false)
  }
};

  useEffect(() => {
    getProductProperties();
  }, []);  
    return (
      <>
        <p>Filtering: {searchText.toUpperCase()}</p>
        <p>Produk Terpilih:</p>        
          <div style={{ maxHeight: 200, overflowY: "auto" }}>
            {skus.map(sku => (
              <Chip
                key={sku}
                label={sku}
                size="small"
                style={{ margin: 4 }}
                onDelete={() => {
                  setSelectedSKU((prev) => 
                    prev.filter((s) => s !== sku)
                  )
                }}
              />
            ))}
          </div>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <Typography>Brand</Typography>
              <Select
                MenuProps={{PaperProps: {style:{maxHeight:300}}}}
                fullWidth
                displayEmpty
                value={form.brand || ""}
                onChange={e => setForm({ ...form, brand: e.target.value || null })}
              >
                <MenuItem value="">(Skip) Brand</MenuItem>
                  {productProps.brands.map(b => (
                    <MenuItem key={b.id} value={b.id}>
                      {b.brand}
                    </MenuItem>
                  ))}
              </Select>       
            </Grid>
            <Grid item xs={4}>
              <Typography>Gender</Typography>
              <Select
                MenuProps={{PaperProps: {style:{maxHeight:300}}}}
                fullWidth
                displayEmpty
                value={form.gender || ""}
                onChange={e => setForm({ ...form, gender: e.target.value })}
              >
                <MenuItem value="">Gender</MenuItem>
                  {productProps.genders.map(g => (
                    <MenuItem key={g.id} value={g.id}>
                      {g.gender}
                    </MenuItem>
                  ))}
              </Select>       
            </Grid>    
            <Grid item xs={4}>
              <Typography>Type</Typography>
              <Select
                MenuProps={{PaperProps: {style:{maxHeight:300}}}}
                fullWidth
                displayEmpty
                value={form.type || ""}
                onChange={e => setForm({ ...form, type: e.target.value })}
              >
                <MenuItem value="">Type</MenuItem>
                  {productProps.types.map(t => (
                    <MenuItem key={t.id} value={t.id}>
                      {t.type}
                    </MenuItem>
                  ))}
              </Select>       
            </Grid>
            <Grid item xs={4}>
              <Typography>Koleksi</Typography>
              <Select
                MenuProps={{PaperProps: {style:{maxHeight:300}}}}
                fullWidth
                displayEmpty
                value={form.koleksi || ""}
                onChange={e => setForm({ ...form, koleksi: e.target.value })}
              >
                <MenuItem value="">Koleksi</MenuItem>
                  {productProps.koleksis.map(k => (
                    <MenuItem key={k.id} value={k.id}>
                      {k.koleksi}
                    </MenuItem>
                  ))}
              </Select>       
            </Grid>               
            <Grid item xs={4}>
              <Typography>Age Group</Typography>
              <Select
                MenuProps={{PaperProps: {style:{maxHeight:300}}}}
                fullWidth
                displayEmpty
                value={form.agegroup || ""}
                onChange={e => setForm({ ...form, agegroup: e.target.value })}
              >
                <MenuItem value="">Age Group</MenuItem>
                  {productProps.agegroups.map(a => (
                    <MenuItem key={a.id} value={a.id}>
                      {a.age_group}
                    </MenuItem>
                  ))}
              </Select>       
            </Grid>  
            <Grid item xs={4}>
              <Autocomplete
                multiple
                options={productProps.usages}
                getOptionLabel={(option) => option.usage}
                value={productProps.usages.filter(u =>
                  (form.usage || []).includes(u.id)
                )}
                onChange={(e, newValues) => {
                  setForm({
                    ...form,
                    usage: newValues.length ? newValues.map(v => v.id) : null   // SIMPAN ID SAJA
                  });
                }}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip
                      variant="outlined"
                      label={option.usage}
                      {...getTagProps({ index })}
                    />
                  ))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    label="Peruntukkan Produk"
                    placeholder="Pilih peruntukkan..."
                  />
                )}
              />     

            </Grid>            
              <Controls.Button
                text={saving ? "Menyimpan..." : `Simpan ke ${skus.length} Produk`}
                onClick={submitBulkUpdate}
                disabled={saving}
              />
          </Grid>
      </>
    )
  }

  return (
    
    <div className="incomplete-product">
      <h1>Incomplete Product List</h1>
      <Paper elevation={2}>
        <Toolbar>
          <Controls.Label label="Search: " />
          <Controls.Input
            inputprops={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
            onChange={handleSearch}
            placeholder="CARI KODE BARCODE..."
          />
          <Controls.Button
            text={
              !isFiltering
                ? "Select All (Filtered)"
                : allFilteredSelected
                  ? "Unselect Filtered"
                  : "Select All (Filtered)"
            }
            color="secondary"
            disabled={!isFiltering || filteredSKUs.length === 0}
            onClick={() => {
              if (allFilteredSelected) {
                // 🔽 UNSELECT FILTERED
                setSelectedSKU((prev) =>
                  prev.filter((sku) => !filteredSKUs.includes(sku))
                );
              } else {
                // 🔼 SELECT FILTERED
                setSelectedSKU((prev) => {
                  const set = new Set([...prev, ...filteredSKUs]);
                  return Array.from(set);
                });
              }
            }}
          />          
          {/* <Controls.Button
            text="Select All (Filtered)"
            color="secondary"
            disabled={filteredSKUs.length === 0}
            onClick={() => {
              setSelectedSKU((prev) => {
                const set = new Set([...prev, ...filteredSKUs]);
                return Array.from(set);
              });
            }}            
          /> */}
          <Controls.Button
            text={`Lengkapi ${selectedSKU.length} Produk`}
            color="primary"
            disabled={selectedSKU.length === 0}
            onClick={() => setOpenBulkPopup(true)}  
          />
        </Toolbar>
        <TblContainer>
          <TblHead />
          <TableBody>
            {recordsAfterPagingAndSorting().map((item) => (
              <TableRow key={item.sku} hover>
                <TableCell padding="checkbox">
                  <Checkbox
                    checked={selectedSKU.includes(item.sku)}
                    onChange={(e) => {
                      e.stopPropagation();
                      handleCheckboxSKU(item.sku);
                    }}
                    color="primary"
                  />
                </TableCell>  
                <TableCell
                  style={{ cursor: "pointer" }}
                  // onClick={() => {
                  //   setOpenPopup(true);
                  //   setDetailItem(item);
                  // }}
                >
                  {item.sku}
                </TableCell>
  
                <TableCell>{item.pname}</TableCell>
                <TableCell>{item.brand}</TableCell>
                <TableCell>{item.koleksi}</TableCell>
                <TableCell>{item.type}</TableCell>
                <TableCell>{item.usage}</TableCell>
                <TableCell>{item.gender}</TableCell>
                <TableCell>{item.age_group}</TableCell>
                <TableCell>Rp. {item.harga}</TableCell>
                <TableCell>{item.stok}</TableCell>
                <TableCell>{(item.tglms
                    ? new Date(item.tglms).toLocaleDateString("id-ID")
                    : "-")}
                    </TableCell>
                {/* <TableCell>
                  <ProductCompletion
                    item={item}
                    location="/products/incompleteProducts"
                  />
                  <ProductDeletion
                    productStatus="incomplete"
                    param={item.sku}
                    location="/products/incompleteProducts"
                  />
                </TableCell> */}
              </TableRow>
            ))}
          </TableBody>
        </TblContainer>
        <TblPagination />
      </Paper>

      {/* <Controls.Popup
        title="Product Detail"
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
      >
        <DetailProduct item={detailItem} />
      </Controls.Popup> */}

        <Controls.Popup
          title={`Lengkapi ${selectedSKU.length} Produk`}
          openPopup={openBulkPopup}
          setOpenPopup={(open) => {
            setOpenBulkPopup(open);
            if(!open){
              setSelectedSKU([]);
            }
          }}           
        >
          <BulkEditProducts 
            skus={selectedSKU} 
            setSelectedSKU={setSelectedSKU}
            refreshList={getIncompleteProducts}
            closeModal={() => setOpenBulkPopup(false)}
          />
        </Controls.Popup>
      <Controls.Notification notify={notify} setNotify={setNotify} />

      <Controls.ConfirmPopup
        confirmPopup={confirmPopup}
        setConfirmPopup={setConfirmPopup}
      />
    </div>
  );
}


